export const aboutUs = {
  aboutUsTitle: 'ÜBER UNS',
  aboutUsText:
    'Wir sind ein etabliertes Startup mit Sitz in Herisau bei St. Gallen. Für unsere Kunden analysieren wir die Bedürfnisse für das jeweilige Umbauprojekt und vermitteln seriöse und passende Firmen für eine kostenlose Beratung und Offertstellung. Die Zufriedenheit unserer Kunden und unserer Anbieter sind dabei unser höchstes Ziel. Dafür arbeitet unser Team täglich.',
  aboutUsTextBroker:
    'Wir sind ein etabliertes Startup mit Sitz in Herisau bei St. Gallen. Für unsere Kunden analysieren wir die Bedürfnisse für das jeweilige Hausprojekt und vermitteln seriöse und passende Firmen für eine kostenlose Beratung und Offertstellung. Die Zufriedenheit unserer Kunden und unserer Anbieter sind dabei unser höchstes Ziel. Dafür arbeitet unser Team täglich.',
  team: 'Das Team',
  whatWeDo: 'Was wir machen',
  partners: 'Unsere Partner',
  universe: 'Das HausHeld-Universum',
  universeText:
    'HausHeld.ch betreibt ein grosses Netzwerk an Tochter-Seiten. So sind wir immer verfügbar, wenn Sie uns suchen.',
  website1: 'FensterKaufen.ch',
  website2: 'KüchenKaufen.ch',
  website3: 'BadKaufen.ch',
  website4: 'SolaranlageKaufen.ch',
  website5: 'HeizungKaufen.ch',
  website6: 'WintergartenKaufen.ch',
  website7: 'GarageKaufen.ch',
  website8: 'BodenlegerVergleich.ch',
  website9: 'CarportKaufen.ch',
  website10: 'GartenbauOfferten.ch',
  website11: 'MalerVergleich.ch',
  website12: 'Schreinerofferten24.ch',
  website13: 'ZaunKaufen.ch',
  website14: 'ZimmermannOfferten.ch',
  website15: 'MaklerVergleichen24.ch',
  website16: 'OffresSallesDeBain.ch',
  website17: 'OffresCuisines.ch',
  aboutUsFaqQuestion1: 'Ist die Benutzung von HausHeld.ch kostenlos?',
  aboutUsFaqQuestion2:
    'Wo ist der Unterschied zwischen HausHeld.ch und "powered by HausHeld"-Seiten?',
  aboutUsFaqQuestion3: 'Erstellt HausHeld.ch selbst Offerten und Kostenzusammen&shy;stellungen?',
  aboutUsFaqQuestion4: 'Woher weiss ich, welche Handwerker mir zugeteilt wurden?',
  aboutUsFaqQuestion5: 'Warum werden mir keine Handwerker zugeteilt?',
  aboutUsFaqQuestion6: 'Warum melden sich die Handwerker nicht bei mir',
  aboutUsFaqQuestion7: 'Darf ich die Handwerker auch selbst kontaktieren?',
  aboutUsFaqQuestion8: 'Mein Projekt hat sich zwischenzeitlich erledigt, was nun?',
  aboutUsFaqAnswer1:
    'Die Benutzung von HausHeld ist für unsere Kunden komplett kostenlos. Wir ermöglichen Ihnen bis zu 3 unverbindliche und kostenlose Erstofferten von Qualitätsanbietern.',
  aboutUsFaqAnswer2:
    'HausHeld.ch ist unsere zentrale Plattform. Für spezifische Bereiche ermöglichen wir Ihnen spezialisierte Plattformen. Ihre Anfrage können Sie so gleichermassen auf der zentralen Plattform, wie auch auf den spezialisierten Unterseiten "powered by Hausheld" erstellen.',
  aboutUsFaqAnswer3:
    'Hausheld.ch bietet Ihnen keine selbst erstellten Offerten an. Für die Offertenstellung sind die Ihnen vermittelten Handwerkbetriebe zuständig.',
  aboutUsFaqAnswer4:
    'Hausheld.ch sucht Ihnen die passendsten Handwerkbetriebe aus. Somit können Sie nicht im vorhinein wissen, welche Handwerkbetriebe Ihnen vermittelt werden.',
  aboutUsFaqAnswer5:
    'Wir sind stehts bemüht, unser Partnernetzwerk zu erweitern. Es kann allerdings vorkommen, dass in Teils Regionen oder bei spezifischen Anfragen, keine passenden Partner verfügbar sind.',
  aboutUsFaqAnswer6:
    'Es kann vorkommen, dass Sie die Partnerbetriebe telefonisch verpassen. Gerne können Sie sich direkt bei den vermittelten Partner melden, oder sich mit uns in Verbindung setzen. Wir helfen gerne bei der Kontakterstellung.',
  aboutUsFaqAnswer7:
    'Ja, dies ist sogar erwünscht. Sie erhalten von uns sämtliche wichtigen Kontaktdaten der Ihnen zugeteilten Handwerksbetrieben. Sie müssen nicht warten, bis sich die Partnerbetriebe melden. Gerne dürfen Sie sie bereits im Vorfeld kontaktieren.',
  aboutUsFaqAnswer8:
    'Dies kann vorkommen. Bitte geben Sie in diesem Fall uns kurz Bescheid, damit wir unsere Partnerbetriebe darüber informieren können.',
  coCEO1: 'co-CEO, co-Founder, VR',
  coCEO1Description: 'ist zuständig für die Strategie, Finanzen und Mitarbeiterführung.',
  coCEO2: 'co-CEO, co-Founder, VR',
  coCEO2Description: 'ist zuständig für Innovation, Produktentwicklung und Vertrieb.',
  coFounder: 'Leiter Software, co-Founder, VR',
  coFounderDescription:
    'ist zuständig für die technische Konzeption, Programmierung und das Testing unserer Portale.',
  vrp: 'VRP',
  vrpDescription: 'ist Präsident vom Verwaltungsrat.',
  vr: 'VR',
  vrDescription: 'ist Mitglied vom Verwaltungsrat.',
  assistent: 'Assistent der Geschäftsleitung',
  assistentDescription: 'unterstützt die Geschäftsleitung in wichtigen Themen.',
  headPartner: 'Leiterin Partnerschaften',
  headPartnerDescription: 'ist im Bereich der Partnerbetreuung tätig.',
  partnerAcquisition: 'Partnerakquise',
  partnerAcquisitionDescription: 'ist im Bereich der Partner-Akquise tätig.',
  salesAgent: 'Sales Agent',
  salesAgentDescription: 'ist als Sales Agent tätig.',
  headDeveloper: 'Leiter Webentwicklung',
  headDeveloperDescription: 'ist Leiter im Bereich Webentwicklung.',
  developer: 'Softwareentwicklung',
  developerDescription: 'entwickelt unsere Webseiten, Portale und Backends.',
  headDesign: 'Leiter Design',
  headDesignDescription: 'ist im Bereich User Interface & Design tätig.',
  headMarketing: 'Leiter Marketing',
  headMarketingDescription: 'ist Leiter im Bereich Marketing.',
  marketing: 'Marketing',
  marketingDescription: 'ist im Bereich Marketing tätig.',
  businessDevelopment: 'Business Developement',
  businessDevelopmentDescription: 'ist im Bereich Business Development tätig.',
  headCustomerValidation: 'Leiter Kundenvalidierung & -service',
  headCustomerValidationDescription: 'leitet das Validierungsteam und den Kundenservice.',
  validation: 'Kundenvalidierung',
  validationDescription: 'ist im Bereich Kundenservice und in der Leadvalidierung tätig.',
  employeeAlt: 'Mitarbeiterphoto',
  clerk: 'Sachbearbeiterin Buchhaltung',
  clerkDescription: 'ist im Bereich der Sachbearbeitung tätig.',
  collection: 'Inkassobeauftragter',
  collectionDescription: 'ist der Inkassobeauftragter der Firma.',
  assistant: 'Assistenz der Geschäftsleitung',
  assistantDescription: 'ist als Assistenz der Geschäftsleitung tätig.',
}
